import React from 'react';
export const useGetGrantDetails = () => {
  const [tabValue, setTabValue] = React.useState(0);
  return { tabValue, setTabValue };
};
